import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/Layout"
import PageHeader from "../components/sections/PageHeader"
import Comments from "../components/sections/Comments"
import ProjectContent from "../components/sections/ProjectContent"
import PortfolioSimilares from "../components/sections/PortfolioSimilares"
import Contact from "../components/sections/Contact"

const ProjectItem = props => {
  const project = props.data.markdownRemark

  return (
    <Layout
      location={props.location}
      seo={{
        title: project.frontmatter.title,
        description: project.frontmatter.description,
        image: project.frontmatter.image.publicURL,
      }}
    >
      <PageHeader
        title={project.frontmatter.title}
        category={project.frontmatter.category}
        size={`sm`}
        customBg={project.frontmatter.image.publicURL}
      />

      <ProjectContent
        title={project.frontmatter.title}
        description={project.frontmatter.description}
        cliente={project.frontmatter.client}
        proposta={project.frontmatter.proposta}
        date={project.frontmatter.date}
        gallery={project.frontmatter.gallery.map(i => i.publicURL)}
        link_ext={project.frontmatter.link_ext}
        image={project.frontmatter.image.publicURL}
        category={project.frontmatter.category}
      />

      <Comments
        url={project.fields.slug}
        title={project.frontmatter.title}
        category="projects"
      ></Comments>

      <PortfolioSimilares />

      <Contact variant={`sm`} />
    </Layout>
  )
}

export const query = graphql`
  query Project($slug: String) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      fields {
        slug
      }
      frontmatter {
        title
        description
        client
        proposta
        link_ext
        image {
          publicURL
        }
        category
        gallery {
          publicURL
        }
        date(locale: "pt-br", formatString: "MMM/YYYY")
      }
    }
  }
`

export default ProjectItem
